import React from 'react'
import {useTranslation} from 'react-i18next'
import {RadarChart} from '../../CommonComponents'
import "./SoftSkillsExample.scss"

export const CompanySoftSkillsExample = ({example}) => {
    const {t} = useTranslation();

    return (
        <div className="companySoftSkillsExample">
            <RadarChart rmSoftSkills={example.softSkills} onClick={() => {
            }}/>
            <h2>{t(example.name)}</h2>
            <p>{t(example.description)}</p>
        </div>
    )
}
